import { isAxiosError } from 'axios';

type ApiErrorDetails = {
	status: number | undefined;
	reason: string | undefined;
	type: string | undefined;
};

export const getApiErrorDetails = (error: unknown): ApiErrorDetails | null => {
	if (!isAxiosError(error)) {
		return null;
	}

	const data: unknown = error.response?.data;
	const body = typeof data === 'object' && data !== null ? data : undefined;

	return {
		status: error.response?.status,
		reason:
			body && 'reason' in body && typeof body.reason === 'string'
				? body.reason
				: undefined,
		type:
			body && 'type' in body && typeof body.type === 'string'
				? body.type
				: undefined
	};
};
